export const RELEASE_NOTES_URL =
  'https://homecoming-health.notion.site/What-s-new-9c25819e2a2e47afb3635c10173418f8';

export const DATA_USE_URL = 'https://www.homecoming.health/data-use-policy';
export const TERMS_OF_SERVICE_URL =
  'https://www.homecoming.health/terms-of-service';
export const PRIVACY_POLICY_URL =
  'https://www.homecoming.health/privacy-policy';

export const DEMO_CLIENT_NOTION_URL =
  'https://homecoming-health.notion.site/Set-up-your-demo-client-f0aef6e6dd104d52b2bccec403f016f3';

export const HOMEPAGE_URL = 'https://homecoming.health';

export const DEFAULT_FREE_CLIENT_COUNT = 2;

export const DragTypes = {
  LIBRARY_ITEM: 'libraryItem',
};

// Form auto-save constants
export const FORM_AUTO_SAVE_DEBOUNCE_MS = 2000; // Default debounce time for form auto-save
export const FORM_DRAFT_REFETCH_DELAY_MS = 500; // Delay before refetching after draft save
export const FORM_RESTORE_SETVALUE_DELAY_MS = 100; // Delay for form restoration (deprecated, kept for compatibility)
export const MULTI_FORM_FETCH_DELAY_MS = 50; // Delay between multi-form fetch requests
